'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'gamepad-modern';
var width = 576;
var height = 512;
var aliases = [127918,63676,"gamepad-alt"];
var unicode = 'e5a2';
var svgPathData = 'M576 150.1l0 329.9-177.3 0-32-96-157.4 0-32 96-177.3 0 0-329.9 118.1-118.1 339.9 0 118.1 118.1zM48 169.9l0 262.1 94.7 0 32-96 226.6 0 32 96 94.7 0 0-262.1-89.9-89.9-300.1 0-89.9 89.9zM184 200l48 0 0 48-48 0 0 48-48 0 0-48-48 0 0-48 48 0 0-48 48 0 0 48zm200 88a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm48-80a32 32 0 1 1 0-64 32 32 0 1 1 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGamepadModern = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;